// @core/api/endpoints/webhook/enable_endpoint.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  EnableEndpointRequest,
  EndpointResponse,
} from '../../../types/webhook';

const BASE_PATH = '/webhook';

/**
 * Enable webhook endpoint
 * Activates a disabled webhook endpoint. The endpoint will resume receiving events for all subscribed event types.
 */
export async function EnableEndpoint(
  endpoint_id: string,
  data: EnableEndpointRequest,
  options?: RequestOptions
): Promise<EndpointResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/endpoints/:endpoint_id/enable`;
  requestPath = requestPath.replace(':endpoint_id', encodeURIComponent(endpoint_id));
  const requestOptions = options;
  return client.post<EndpointResponse>(requestPath, data, requestOptions);
}
